module.exports = __webpack_public_path__ + "img/learner-quiz-Collaborator.7984ddab.png";